import { ArrowRight, CheckCircle, X } from 'lucide-react';
import { Button } from '../ui/button';
import { PACKS } from './moana-data';
import { Eyebrow } from './MoanaHero';

export const MoanaPacks = ({ onOpenPackModal }) => (
  <section id="packs" className="py-20 bg-white" data-testid="packs-section">
    <div className="max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-10">
      <div className="mb-12">
        <Eyebrow>Packs delegation totale</Eyebrow>
        <h2 className="text-3xl sm:text-4xl font-bold text-[#1F2937]">
          Choisissez votre niveau <em className="italic text-[#F59E0B]">d'accompagnement</em>
        </h2>
        <p className="text-sm text-gray-500 leading-relaxed mt-2 max-w-[580px]">
          En Mode 1 — Délégation totale : bulletins à l'acte au tarif dégressif + abonnement outils selon le niveau souhaité.
        </p>
      </div>
      <div className="grid lg:grid-cols-3 gap-5">
        {PACKS.map(pack => (
          <div key={pack.name} className={`bg-white border rounded-xl overflow-hidden flex flex-col hover:-translate-y-1 hover:shadow-lg transition-all ${pack.popular ? 'border-[#F59E0B] ring-2 ring-[#F59E0B]/20' : 'border-gray-200'}`} data-testid={`pack-${pack.name.toLowerCase()}`}>
            <div className={`${pack.bgClass} p-7 relative`}>
              {pack.popular && (
                <span className="absolute top-3.5 right-3.5 bg-[#F59E0B] text-[#0F766E] text-[10px] font-bold tracking-wider uppercase px-2.5 py-1 rounded">Populaire</span>
              )}
              <p className="text-[10px] font-bold tracking-[0.2em] uppercase text-[#F59E0B] mb-2">{pack.tier}</p>
              <h3 className="text-2xl font-bold text-white mb-1">{pack.name}</h3>
              <p className="text-xs text-white/55 italic">{pack.tagline}</p>
              <div className="mt-4 pt-3.5 border-t border-white/10">
                <p className="text-[10px] font-semibold tracking-[0.14em] uppercase text-white/40 mb-1">Abonnement outils mensuel</p>
                {pack.abo ? (
                  <p className="text-xl font-bold text-white">{pack.abo} <span className="text-xs font-normal text-white/45">/ mois</span></p>
                ) : (
                  <p className="text-sm text-white/35 italic">Aucun abonnement</p>
                )}
              </div>
            </div>
            <div className="p-7 flex-1 flex flex-col">
              <ul className="space-y-0 mb-5 flex-1">
                {pack.features.map((f, i) => (
                  <li key={i} className="flex gap-2.5 text-sm py-2 border-b border-gray-100 last:border-0 items-start">
                    {f.ok ? (
                      <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
                    ) : (
                      <X className="w-4 h-4 text-gray-300 flex-shrink-0 mt-0.5" />
                    )}
                    <span className={f.ok ? 'text-gray-600' : 'text-gray-300'}>
                      {f.bold ? <strong className="text-[#1F2937]">{f.text}</strong> : f.text}
                    </span>
                  </li>
                ))}
              </ul>
              {pack.dpae && (
                <p className="text-xs text-gray-400 mb-4">· DPAE : <strong className="text-[#1F2937]">{pack.dpae}</strong></p>
              )}
              <div className="bg-[#0D9488]/10 rounded-lg p-3 text-xs text-[#0D9488] italic leading-relaxed mb-5">
                <strong className="not-italic">Ideal :</strong> {pack.ideal}
              </div>
              <Button
                onClick={() => onOpenPackModal(pack.name)}
                className="w-full bg-[#F59E0B] hover:bg-[#D97706] text-white font-semibold py-5"
                data-testid={`pack-cta-${pack.name.toLowerCase()}`}
              >
                Souscrire au Pack {pack.name} <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
